import request from '../request';
import getEnv from '../getEnv';
const sid = 'ky.api';
const type = 395;
async function getHost(envArg) {
    const env = envArg || (await getEnv());
    if (env.type === 2) {
        return 'https://id.kwaiying.com';
    }
    return 'https://kyid.staging.kuaishou.com';
}
export async function sendCode(phone) {
    return request.post((await getHost()) + '/pass/ky/web/sms/code', {
        countryCode: '+86',
        type,
        phone,
    }, {
        // @ts-ignore
        disableSign: true,
        withCredentials: true,
    });
}
export async function login(phone, code, callbackUrl) {
    const env = await getEnv();
    const res = await request.post((await getHost(env)) + '/pass/ky/web/login/mobileCode', {
        sid,
        phone,
        type,
        countryCode: '+86',
        smsCode: code,
        registerOpen: true,
    }, {
        // @ts-ignore
        disableSign: true,
        withCredentials: true,
    });
    window.location.href = `${env.url}/rest/infra/sts?sid=${sid}&authToken=${res[sid + '.at']}&followUrl=${callbackUrl}`;
}
export async function getUserInfo() {
    return request.get('/rest/n/kmovie/app/user/info/getWebUserInfo');
}
